<template>
  <b-dropdown
    aria-role="list"
    class="addToSpace"
    :close-on-click="false"
    @active-change="handleDropdownChange"
  >
    <b-button slot="trigger" :size="size" type="is-primary">
      Add to Space</b-button
    >
    <b-dropdown-item
      class="dropdown-item"
      v-if="!canAddToTheseSpaces.length && !loading"
    >
      <div class="media">
        <b-icon icon="plus" size="is-small" class="media-left"></b-icon>
        <span>Create a new space!</span>
      </div>
    </b-dropdown-item>
    <b-dropdown-item
      class="dropdown-item"
      disabled
      v-if="!canAddToTheseSpaces.length && loading"
    >
      <b-progress size="is-small"></b-progress>
    </b-dropdown-item>
    <b-dropdown-item
      class="dropdown-item"
      v-for="(s, i) in canAddToTheseSpaces"
      :key="i"
      :disabled="placing === s.id"
      ><space-dropdown-item :space="s" :placing="placing" :focused="focused" />
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
import { bus } from "@/components/spaces/bus.js";
import { mapGetters } from "vuex";
import SpaceDropdownItem from "@/components/spaces/Modal.SpaceDropdownItem";

export default {
  components: { SpaceDropdownItem },
  computed: { ...mapGetters(["currentUser", "isAuthenticated"]) },
  props: {
    size: { default: "is-small" },
  },
  data() {
    return {
      focused: false,
      placing: false,
      loading: false,
      canAddToTheseSpaces: [],
    };
  },
  mounted() {
    bus.$on("placing-event", spaceID => {
      this.placing = spaceID;
    });
    bus.$on("placing-complete", addedToThisSpace => {
      this.placing = false;
      this.canAddToTheseSpaces = this.canAddToTheseSpaces.filter(
        s => s.id !== addedToThisSpace,
      );
    });
  },
  methods: {
    handleDropdownChange($event) {
      if ($event === true && !this.canAddToTheseSpaces.length) {
        this.loading = true;
        setTimeout(async () => {
          this.canAddToTheseSpaces = this.isAuthenticated
            ? await this.currentUser.$getSpaces()
            : [];
          this.loading = false;
        }, 1000);
      }
      this.focused = $event;
    },
  },
  beforeDestroy() {
    bus.$off();
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/bulma_overrides.scss";

.media {
  font-weight: 400;
}

.dropdown-item {
  padding-right: 1rem !important;
}
</style>
